module.exports = __webpack_public_path__ + "static/media/Page11.5778614c.png";